<!--
 * @Author: 刘小博
 * @Date: 2022-11-23 18:41:20
 * @LastEditTime: 2023-01-17 13:41:31
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\components\viewHeader\ViewHeader.vue
 * 路由標題
-->
<template>
  <div class="view-header">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </a-breadcrumb-item>
      <!--二级菜单-->
      <a-breadcrumb-item>{{ parentName }}</a-breadcrumb-item>
      <a-breadcrumb-item
        v-for="(item, index) in pageMeta.breadcrumb"
        :key="index"
      >
        <router-link :to="{ name: item.name, params: routerParams, query: routerQuery }">{{
          item.title
        }}</router-link>
      </a-breadcrumb-item>
      <slot name="router"></slot>

      <a-breadcrumb-item>{{ title || pageMeta.title }}</a-breadcrumb-item>
    </a-breadcrumb>
    <h1 class="title">
      {{ title || pageMeta.title }}
      <slot name="icon"> </slot>
    </h1>
    <div class="func-btn">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewHeader',
  props: {
    parentName: {
      type: String,
      require: true,
      default: '',
    },
    title: {
      type: String,
      require: true,
      default: '',
    },
    routerParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
    routerQuery:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    pageMeta() {
      return this.$route.meta
    },
  },
}
</script>

<style></style>
